
    export default {
      path: `/home/runner/work/fase2-website/fase2-website/src/modules/consent-manager/cookie-banner.kpa`,
      template: `<div id="cookie-banner" ref="cookieBanner">
    <div class="blur"></div>
    <div class="banner">
        <div class="info">
            <h3>Diese Webseite verwendet Cookies</h3>

            <p>
                Wir verwenden Cookies, um Inhalte und Anzeigen zu personalisieren, 
                Funktionen für soziale Medien anbieten zu können und die Zugriffe auf 
                unsere Website zu analysieren. 
                Außerdem geben wir Informationen zu Ihrer Verwendung unserer Website an unsere Partner für soziale Medien, 
                Werbung und Analysen weiter. Unsere Partner führen diese Informationen möglicherweise mit weiteren Daten zusammen, 
                die Sie ihnen bereitgestellt haben oder die sie im Rahmen Ihrer Nutzung der Dienste gesammelt haben. 
                Weitere Informationen findest du in der <a href="/datenschutzerklaerung" target="_blank" rel="noopener noreferrer">Datenschutzerklärung</a> und im <a href="/impressum" target="_blank" rel="noopener noreferrer">Impressum</a>.
            </p>
        </div>

        <div class="settings">
            <div>
                <label>
                    <input type="checkbox" id="consent-necessary" disabled checked>
                    Notwendige Cookies
                </label>
                <label>
                    <input type="checkbox" id="consent-preferences">
                    Präferenzen
                </label>
                <label>
                    <input type="checkbox" id="consent-statistics">
                    Statistiken
                </label>
                <label>
                    <input type="checkbox" id="consent-marketing">
                    Marketing
                </label>
            </div>

            <div>
                <button id="accept-selection" ref="accept-selection" onClick="acceptSelectedCookies">Auswahl erlauben</button>
                <button id="accept-cookies" ref="accept-cookies" onClick="acceptAllCookies">Alle Cookies akzeptieren</button>
                <button id="reject-cookies" ref="reject-cookies" onClick="rejectAllCookies">Alles ablehnen</button>
            </div>
        </div>
    </div>
</div>`,
      style: `cookie-banner {
  display: none;
}
cookie-banner #cookie-banner {
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  z-index: 10000;
}
cookie-banner #cookie-banner .blur {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
  transition: left 0.2s ease-in-out 0s, -webkit-backdrop-filter 0.4s ease-in-out 0s;
  transition: left 0.2s ease-in-out 0s, backdrop-filter 0.4s ease-in-out 0s;
  transition: left 0.2s ease-in-out 0s, backdrop-filter 0.4s ease-in-out 0s, -webkit-backdrop-filter 0.4s ease-in-out 0s;
  z-index: 1;
}
cookie-banner #cookie-banner .banner {
  position: absolute;
  bottom: 0;
  left: 0;
  width: calc(100% - 64px);
  max-height: calc(100vh + 3px);
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  margin: 0 32px;
  padding: 20px 10px;
  background-color: #ffffff;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.3);
  border: 1px solid #62be6a;
  border-width: 3px 3px 0 3px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  z-index: 2;
}
cookie-banner #cookie-banner .banner .info {
  overflow-y: scroll;
}
cookie-banner #cookie-banner .banner .settings div {
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
}
cookie-banner #cookie-banner .banner .settings div label {
  font-size: 14px;
  cursor: pointer;
}
cookie-banner #cookie-banner .banner .settings div #accept-cookies, cookie-banner #cookie-banner .banner .settings div #reject-cookies, cookie-banner #cookie-banner .banner .settings div #accept-selection {
  background-color: #4CAF50;
  color: white;
  border: none;
  padding: 10px 20px;
  font-size: 14px;
  cursor: pointer;
  border-radius: 4px;
  transition: background-color 0.3s;
}
cookie-banner #cookie-banner .banner .settings div #accept-cookies:hover, cookie-banner #cookie-banner .banner .settings div #reject-cookies:hover {
  background-color: #45a049;
}
cookie-banner #cookie-banner .banner .settings div #accept-cookies:focus, cookie-banner #cookie-banner .banner .settings div #reject-cookies:focus {
  outline: none;
}
cookie-banner #cookie-banner .banner .settings div #reject-cookies {
  background-color: #f44336;
}
cookie-banner #cookie-banner .banner .settings div #reject-cookies:hover {
  background-color: #e53935;
}
cookie-banner #cookie-banner .banner .settings div #accept-selection {
  background-color: #c7c7ce;
  color: #000000;
}
cookie-banner #cookie-banner .banner .settings div #accept-selection:hover {
  background-color: #A7A7AF;
}
cookie-banner #cookie-banner .banner .settings div #accept-selection:focus {
  outline: none;
}
@media (max-width: 540px) {
  cookie-banner #cookie-banner .banner {
    width: 100%;
    margin: 0;
    border-width: 3px 0 0 0;
    border-radius: 0;
  }
}

cookie-banner.open {
  display: block;
}
cookie-banner.open #cookie-banner .blur {
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
  transition: left 0.3s ease-in-out 0s, -webkit-backdrop-filter 0.5s ease-in-out 0s;
  transition: left 0.3s ease-in-out 0s, backdrop-filter 0.5s ease-in-out 0s;
  transition: left 0.3s ease-in-out 0s, backdrop-filter 0.5s ease-in-out 0s, -webkit-backdrop-filter 0.5s ease-in-out 0s;
}`,
      script: `(async () => { "use strict";
return {
    data: {},
    methods: {
        acceptAllCookies() {
            consentManager.acceptAllCookies();
            consentManager.closeCookieBanner();
        },
        rejectAllCookies() {
            consentManager.rejectAllCookies();
            consentManager.closeCookieBanner();
        },
        acceptSelectedCookies() {
            consentManager.acceptSelectedCookies();
            consentManager.closeCookieBanner();
        },
        check() {
            const currentConsent = consentManager.getConsent();
            for (const key in currentConsent) {
                $refs.cookieBanner.querySelector(\`#consent-$-{key}\`).checked = currentConsent[key];
            }
        }
    },
    mounted: function () {
        if (consentManager.shouldHideBanner()) {
            return;
        }
        if (!consentManager.hasConsentBeenGiven()) {
            consentManager.openCookieBanner();
        }
    },
    events: [
        [
            'cookieBannerOpen', window, function (event) {
                this.check();
                const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
                document.body.style.overflow = 'hidden';
                document.body.style.paddingRight = \`$-{scrollbarWidth}px\`;
                $refs.cookieBanner.parentElement.classList.add('open');
            }
        ],
        [
            'cookieBannerClose', window, function (event) {
                document.body.style.overflow = '';
                document.body.style.paddingRight = '';
                $refs.cookieBanner.parentElement.classList.remove('open');
            }
        ],
    ],
};
 })()`
    };
  